import { useState, useEffect, useCallback } from 'react';

export const useScrolled = (threshold = 50) => {
  const [isScrolled, setIsScrolled] = useState(false);

  const handleScroll = useCallback(() => setIsScrolled(window.scrollY > threshold), [threshold]);

  useEffect(() => {
    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  return isScrolled;
};
